module.exports = __webpack_public_path__ + "img/43_19.e9af6ade.png";